import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNonNaNNumber, localTimeToUTC, utcToLocalTime } from '@iotv/iotv-v3-types';
import { Slot } from '@iotv/lfc-devices';
import { Button, FormLabel, Stack, TextField } from '@mui/material';
import { useContext, useReducer } from 'react';
import { AppMainViewContext } from '../../../../../../ContextProviders/AppContextProvider';
import { Timezone } from '../../common/Timezone';
import { EntityProgrammeContext } from '../Reducers/ProgrammeReducer';
const debug = process.env.REACT_APP_DEBUG && false;
const isUpdateSlotAction = (x) => {
    const c = x ?? {};
    return !!c && c.type === 'UpdateSlot' && !!c.value && c.value.slot instanceof Slot;
};
const reducer = (prev, action) => {
    const update = { ...prev };
    if (isUpdateSlotAction(action)) {
        const { value: { slot }, } = action;
        update.slot = slot;
        update.timeslot = slot.timeslot;
    }
    else {
        const { localHr, localMin, duration_mins } = action;
        if (isNonNaNNumber(duration_mins) && duration_mins > 0) {
            update.duration_mins = Math.floor(duration_mins);
            if (update.timeslot) {
                update.timeslot.duration_mins = duration_mins;
            }
        }
        if (isNonNaNNumber(localHr)) {
            const { utcHour, utcMin } = localTimeToUTC(localHr, update.localMin, update.utcMinsOffset);
            const updatedTimeslot = {
                utc_start_hour: utcHour,
                utc_start_min: utcMin,
                duration_mins: update.duration_mins,
            };
            update.timeslot = updatedTimeslot;
            update.localHr = localHr;
        }
        if (isNonNaNNumber(localMin)) {
            const { utcHour, utcMin } = localTimeToUTC(update.localHr, localMin, update.utcMinsOffset);
            const updatedTimeslot = {
                utc_start_hour: utcHour,
                utc_start_min: utcMin,
                duration_mins: update.duration_mins,
            };
            update.timeslot = updatedTimeslot;
            update.localMin = localMin;
        }
    }
    return update;
};
const getDefaultState = (slot, utcMinsOffset) => {
    const { localHr, localMin } = utcToLocalTime(slot.timeslot.utc_start_hour, slot.timeslot.utc_start_min, utcMinsOffset ?? 0);
    const defaultState = {
        slot,
        timeslot: slot.timeslot,
        utcMinsOffset: utcMinsOffset ?? 0,
        duration_mins: slot.timeslot.duration_mins,
        localHr,
        localMin,
    };
    debug && console.log(`default state `, defaultState);
    return defaultState;
};
export const EditSlot = ({ close, slot }) => {
    const [{ ipData }] = useContext(AppMainViewContext);
    const { utcMinsOffset } = ipData ?? {};
    const [state, dispatch] = useContext(EntityProgrammeContext);
    const { scheduler } = state;
    const defaultState = getDefaultState(slot, utcMinsOffset);
    const [localState, localDispatch] = useReducer(reducer, defaultState);
    const { slot: stateSlot, duration_mins, localHr, localMin, timeslot } = localState;
    // debug && console.log("INFO: Edit Slot has", state);
    const handleModifySlot = () => {
        if (scheduler && stateSlot && timeslot) {
            const modifyRes = scheduler.modifyTimeslot({
                oldTimeslot: stateSlot.timeslot,
                newTimeslot: timeslot,
            });
            if (modifyRes) {
                const newSlot = structuredClone(stateSlot);
                newSlot.timeslot = timeslot;
                const updateSlotAction = {
                    type: 'UpdateSlot',
                    value: { slot: newSlot },
                };
                debug && console.log(`INFO: EditSlot handleModifySlot dispatching`, updateSlotAction);
                localDispatch(updateSlotAction);
            }
            else {
                console.log(`WARN: EditSlot handleModifySlot received no modifyRes on change`, {
                    oldTimeslot: stateSlot.timeslot,
                    newTimeslot: timeslot,
                    modifyRes,
                });
            }
            const action = {
                type: 'Recalculate',
                value: null,
            };
            dispatch(action);
            close();
        }
    };
    return duration_mins && isNonNaNNumber(localHr) && isNonNaNNumber(localMin) ? (_jsxs(Stack, { gap: 1, marginBlockStart: 1, width: 'min(70cqw, 30em)', children: [_jsxs(Stack, { direction: 'row', justifyContent: 'space-between', children: [_jsx(FormLabel, { children: "Start" }), _jsx(Timezone, {})] }), _jsxs(Stack, { direction: 'row', gap: 1, children: [_jsx(TextField, { value: localHr,
                        label: 'Hour',
                        type: 'number',
                        size: 'small',
                        onChange: (e) => {
                            localDispatch({ localHr: parseInt(e.target.value) });
                        } }), _jsx(TextField, { value: localMin,
                        label: 'Minute',
                        type: 'number',
                        size: 'small',
                        onChange: (e) => {
                            localDispatch({
                                localMin: parseInt(e.target.value),
                            });
                        } })] }), _jsx(TextField, { value: duration_mins,
                label: 'Slot duration (minutes)',
                type: 'number',
                size: 'small',
                onChange: (e) => {
                    localDispatch({ duration_mins: parseInt(e.target.value) });
                } }), _jsx(Button, { variant: 'contained',
                onClick: () => handleModifySlot(), children: "Edit slot" })] })) : null;
};
